module.exports = __webpack_public_path__ + "img/test.73ab025a.png";